import { createBrowserClient } from '@supabase/ssr';
import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

// Validate environment variables
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
const supabaseServiceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Client-side Supabase client with proper cookie configuration for SSR
export const supabaseClient = createBrowserClient<Database>(supabaseUrl, supabaseAnonKey);

// Server-side Supabase admin client (use with caution, only in server components or API routes)
export const supabaseAdmin = () => {
  if (!supabaseServiceRoleKey) {
    throw new Error('Missing Supabase service role key');
  }
  return createClient<Database>(supabaseUrl, supabaseServiceRoleKey);
};

// Utility to get authenticated client with user token (for API routes or Edge Functions)
export const supabaseWithAuth = (authToken: string) =>
  createClient<Database>(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
    },
  });